import { StandardDeliveryDeviceHigherCategoryReport } from '../../../../../apis/graphql/types';
import { getObjectWithoutTypeName } from '../../../../../apis/graphql/utils';
import { DynamicFilters } from '../../../types/reports';

export const getDynamicFilters = (report: StandardDeliveryDeviceHigherCategoryReport): DynamicFilters => {
  return {
    adProduct: report.filters.adProduct || undefined,
    startDate: report.filters.startDate ? getObjectWithoutTypeName(report.filters.startDate) : undefined,
    endDate: report.filters.endDate ? getObjectWithoutTypeName(report.filters.endDate) : undefined,
    cpm: report.filters.cpm ? getObjectWithoutTypeName(report.filters.cpm) : undefined,
    revenue: report.filters.revenue ? getObjectWithoutTypeName(report.filters.revenue) : undefined,
    deliveryGoal: report.filters.deliveryGoal ? getObjectWithoutTypeName(report.filters.deliveryGoal) : undefined,
    lifetimeCompletions: report.filters.lifetimeCompletions
      ? getObjectWithoutTypeName(report.filters.lifetimeCompletions)
      : undefined,
  };
};
